// extracted by mini-css-extract-plugin
module.exports = {"group":"widget-space--group--NW7DN","title":"widget-space--title--X7n9M","list":"widget-space--list--2fWWL","listNonVirtualized":"widget-space--listNonVirtualized--3fm-m"};